import * as React from 'react';

import { PageHeader } from '../../components/core/PageHeader';
import { useEffect } from 'react';
import { onPageDidMount, onPageWillUnmount } from '../../redux/core';
import { useDispatch } from 'react-redux';
import { fetchWebhookSubscribers } from '../../api/webhooks';
import { Subscriber } from '../../api/webhooks.types';
import { useState } from 'react';
import { Checkbox, CheckboxVisibility, ConstrainMode, Dialog, IColumn, Link, ShimmeredDetailsList, Stack } from '@fluentui/react';
import { ROUTES } from '../../config/routes';
import { useNavigate } from 'react-router-dom';

export const Webhooks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subscribers, setSubscribers] = useState<Record<string, Subscriber>>();
  const [fetching, setFetching] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);

  useEffect(() => {
    dispatch(onPageDidMount('Webhooks'));
    setFetching(true);
    fetchWebhookSubscribers().then((data) => {
      setSubscribers(data);
      setFetching(false);
    });
    return () => {
      dispatch(onPageWillUnmount('Webhooks'));
    };
  }, [dispatch]);

  const actions = {
    items: [
      {
        key: 'add_subscriber',
        name: 'Add subscriber',
        disabled: true,
        iconProps: { iconName: 'Add' },
        onClick: () => setOpenCreate(true),
      },
    ],
  };

  const createDialog = () => (
    <Dialog
      hidden={false}
      title="Create webhook subscriber"
      onDismiss={() => setOpenCreate(false)}
      modalProps={{
        isBlocking: true,
      }}
    >
      <div>todo</div>
    </Dialog>
  );

  const columns: IColumn[] = [
    {
      key: 'subscriberName',
      name: 'Subscriber Name',
      fieldName: 'subscriberName',
      minWidth: 160,
      maxWidth: 200,
      onRender: (item: Subscriber) => <Link onClick={() => navigate(`${ROUTES.webhooks}/${item.subscriberId}`)}>{item.subscriberName}</Link>,
    },
    { key: 'subscriberId', name: 'Subscriber ID', fieldName: 'subscriberId', minWidth: 260, maxWidth: 260 },
    { key: 'eventsFor', name: 'Events For', fieldName: 'eventsFor', minWidth: 260, maxWidth: 260 },
    {
      key: 'types',
      name: 'Webhook types',
      fieldName: 'types',
      minWidth: 200,
      maxWidth: 240,
      onRender: (item: Subscriber) => {
        return (
          <Stack>
            {item.subscribedWebhooks.map((wh, i) => (
              <div key={i}>{`${wh.type} version: ${wh.version} verified: ${wh.verified}`}</div>
            ))}
          </Stack>
        );
      },
    },
    {
      key: 'approved',
      name: 'Approved',
      fieldName: 'approved',
      minWidth: 80,
      maxWidth: 80,
      onRender: (item: Subscriber) => <Checkbox disabled={true} checked={item.approved} />,
    },
  ];

  return (
    <>
      <PageHeader title="Webhooks" actions={actions} />
      <ShimmeredDetailsList
        enableShimmer={fetching}
        compact={true}
        constrainMode={ConstrainMode.horizontalConstrained}
        checkboxVisibility={CheckboxVisibility.hidden}
        items={Object.values(subscribers || {})}
        setKey="set"
        columns={columns}
      />
      {openCreate && createDialog()}
    </>
  );
};
